/**
 * Messages utilisateur pour actions Matériels — jamais d’erreur brute backend.
 */

export function friendlyMaterielActionError(err, fallback) {
  const raw = String(
    err?.data?.error || err?.data?.message || err?.message || ''
  ).trim();
  const status = err?.status || err?.response?.status;

  if (status === 409 || /déjà enregistré|already|P2002|unique/i.test(raw)) {
    return 'Ce numéro de série est déjà enregistré.';
  }
  if (status === 404 || /non trouv/i.test(raw)) {
    return 'Élément introuvable. Actualisez la page puis réessayez.';
  }
  if (status === 403 || /forbidden|permission|non autoris/i.test(raw)) {
    return 'Action non autorisée.';
  }
  if (
    status >= 500 ||
    /network|fetch|timeout|ECONN|Failed to fetch|NetworkError/i.test(raw)
  ) {
    return fallback || 'Problème de connexion. Réessayez.';
  }
  // Message API déjà métier court
  if (raw && raw.length < 120 && !/prisma|sql|stack|at\s+\//i.test(raw)) {
    return raw;
  }
  return fallback || 'Impossible de terminer l’action. Réessayez.';
}
